import { Dispatch } from 'react';
import { Task as NormalizedTask } from 'data/tasks/schema';
import { Task } from 'stores/tasks';

export interface ProjectPhaseType {
  label?: string;
  value?: string | number;
}

export interface InputSeriesType {
  prefix: string;
  name: string;
}

export enum ItemsToDuplicate {
  Description = 'DESCRIPTION',
  Attachments = 'ATTACHMENTS',
  TaskDates = 'TASK_DATES',
  SubTasks = 'SUBTASKS',
  Assignees = 'ASSIGNEES',
  TaskFields = 'TASK_FIELDS',
}

export interface DuplicateTasksInStoreProps {
  projectId: number;
  data: number[];
  requestId: string;
  dispatch: Dispatch<any>;
  to_row: (task: NormalizedTask) => Task;
  shouldUpdateTasksInV1Store: boolean;
}
